export const FOUNDER_COLORS = { maddie: "#244f40", mackenzie: "#a44955" };
export const paymentLabel = (method) =>
  ({ cash: "Cash", card: "Card", venmo: "Venmo", other: "Other" })[method] ||
  "Other";
export const fullAddress = (order) =>
  `${order.customer.address}${order.customer.unit ? ", " + order.customer.unit : ""}, ${order.customer.city}, ID ${order.customer.zip}`;
export function googleDirections(orders) {
  const stops = orders.slice(0, 4),
    url = new URL("https://www.google.com/maps/dir/");
  url.searchParams.set("api", "1");
  url.searchParams.set("travelmode", "driving");
  if (stops.length) {
    url.searchParams.set("destination", fullAddress(stops.at(-1)));
    if (stops.length > 1)
      url.searchParams.set(
        "waypoints",
        stops.slice(0, -1).map(fullAddress).join("|"),
      );
  }
  return url.toString();
}
export function nearbyStops(orders) {
  if (orders.length < 2) return orders;
  const pending = orders.slice(1),
    result = [orders[0]];
  while (pending.length) {
    const from = result.at(-1).coordinates;
    let nearest = 0,
      distance = Infinity;
    if (from)
      pending.forEach((order, i) => {
        const to = order.coordinates;
        if (!to) return;
        const lat = (from.lat - to.lat) * 111,
          lng =
            (from.lng - to.lng) * 111 * Math.cos((from.lat * Math.PI) / 180),
          d = lat * lat + lng * lng;
        if (d < distance) {
          distance = d;
          nearest = i;
        }
      });
    result.push(pending.splice(nearest, 1)[0]);
  }
  return result;
}
